/**
 * The global state selectors
 */

import { createSelector } from 'reselect';


const selectState = (state) => state.get('global');
const selectStateRoute = (state) => state.get('route');
const selectStateForm = (state) => state.get('form');

const makeSelectLocationState = () => {
  let prevRoutingState;
  let prevRoutingStateJS;

  return (state) => {
    const routingState = state.get('route'); // or state.route

    if (!routingState.equals(prevRoutingState)) {
      prevRoutingState = routingState;
      prevRoutingStateJS = routingState.toJS();
    }

    return prevRoutingStateJS;
  };
};

const makeSelectRouteQuery = (key) => createSelector(
  selectStateRoute,
  (state) => state.getIn(['locationBeforeTransitions', 'query', key])
);

const makeSelectFormField = (formName, fieldName) => createSelector(
  selectStateForm,
  (state) => state.getIn([formName, 'values', fieldName])
);

const makeSelectCurrentUser = () => createSelector(
  selectState,
  (state) => state.get('user')
);

const makeSelectLoading = () => createSelector(
  selectState,
  (state) => state.get('loading')
);

const makeSelectError = () => createSelector(
  selectState,
  (state) => state.get('error')
);

const makeSelectErrorMsg = () => createSelector(
  selectState,
  (state) => state.get('customErrorMsg')
);

const makeSelectMessage = () => createSelector(
  selectState,
  (state) => state.get('message')
);

const makeSelectCategories = () => createSelector(
  selectState,
  (state) => state.get('categories')
);

const makeSelectProfiles = () => createSelector(
  selectState,
  (state) => state.get('profiles')
);

const makeSelectRedemptionData = () => createSelector(
  selectState,
  (state) => state.get('redemtionData')
);

export {
  selectState,
  makeSelectLocationState,
  makeSelectRouteQuery,
  makeSelectFormField,
  makeSelectCurrentUser,
  makeSelectLoading,
  makeSelectError,
  makeSelectMessage,
  makeSelectCategories,
  makeSelectProfiles,
  makeSelectRedemptionData,
  makeSelectErrorMsg,
};
